export enum TooltipEnum {
  DrawMode = 'drawMode',
  DrawModeInvalid = 'drawModeInvalid',
  DrawModeValid = 'drawModeValid',
  MapCenterOnUserError = 'mapCenterOnUserError',
  NewFarmPolygon = 'newFarmPolygon',
  NewFarmRadius = 'newFarmRadius',
  WalkingFarmFiltersCleared = 'walkingFarmFiltersCleared'
}
